module.exports = __webpack_public_path__ + "static/media/homePage.8f974d6b.gif";